import { Component } from '@angular/core';

@Component({
  selector: 'about-location-details',
  templateUrl: 'about-location-details.html'
})
export class AboutLocationDetailsPage {
  constructor() {}
}




// WEBPACK FOOTER //
// ./src/pages/about-location-details/about-location-details.ts